import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getBetriebsanweisungTemplates(context, { category } = {}) {
    return axios
      .get("betriebsanweisungTemplate", {
        params: category ? { category } : {},
      })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getBetriebsanweisungTemplateCategories(context) {
    return axios
      .get("betriebsanweisungTemplateCategory")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getBetriebsanweisungTemplateCategoryCounts(context) {
    return axios
      .get("betriebsanweisungTemplateCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  createBetriebsanweisungTemplateCategory(context, payload) {
    return axios
      .post("betriebsanweisungTemplateCategory", payload)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.folder.createdMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateBetriebsanweisungTemplateCategory(context, payload) {
    return axios
      .put("betriebsanweisungTemplateCategory/" + payload.id, payload)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.folder.updatedMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteBetriebsanweisungTemplateCategory(context, id) {
    return axios
      .delete("betriebsanweisungTemplateCategory/" + id)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.folder.deletedMessage"),
        );
        return r;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleBetriebsanweisungTemplate(context, id) {
    return axios
      .get("betriebsanweisungTemplate/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getBetriebsanweisungTemplatePdf(context, id) {
    return axios
      .get("betriebsanweisungTemplate/" + id + "/pdf")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createBetriebsanweisungTemplate(context, payload) {
    return axios
      .post("betriebsanweisungTemplate", payload)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("betriebsanweisung.templateCreated"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateBetriebsanweisungTemplate(context, payload) {
    return axios
      .put("betriebsanweisungTemplate/" + payload.id, payload)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("betriebsanweisung.templateUpdated"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteBetriebsanweisungTemplate(context, id) {
    return axios
      .delete("betriebsanweisungTemplate/" + id)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("betriebsanweisung.templateDeleted"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
